import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {TaskManagerService} from '@features/task-manager/services/task-manager.service';
import {CommandService} from '@core/services/command.service';
import {take, takeUntil} from 'rxjs/operators';
import {SnackBarService} from '@core/services/snack-bar.service';
import {TicketAssignee, TicketOwner} from '@features/task-manager/constants/task-manager.constants';
import {FormControl} from '@angular/forms';
import {Subject} from 'rxjs';
import {TaskManagerState} from '@features/task-manager/store/task-manager.reducer';
import {select, Store} from '@ngrx/store';
import {getTaskViewUpdateInfo} from '@features/task-manager/store/task-manager.selector';
import {getUserInfo} from '@shared/store/selectors/security.selector';
import {SecurityState} from '@shared/store/reducers/security.reducer';
import {UserModel} from '@shared/models/user.model';
import {GraphqlContentScope} from "@shared/models/graphql-content-scope.model";
import {ContentScope} from "@shared/commands/command-base";


@Component({
    standalone: false,
    selector: 'particle-task-header',
  templateUrl: './task-header.component.html',
  styleUrls: ['./task-header.component.scss']
})
export class TaskHeaderComponent implements OnInit, OnDestroy {
  id = 'task-header';
  card: any;
  board: any;
  @Input() data: any;
  @Input() taskMenuItemsMapper: any = {};
  @Output() actionEvent$: EventEmitter<any> = new EventEmitter();
  isTitleEditing = false;
  hasAddAttachmentPermission = true;
  unSubscribe = new Subject<void>();
  hasPermission = true;
  isSupportMember = false;
  canOpenChat = false;
  currentUser: UserModel;
  hasCommentPermission = true;

  constructor(private taskManagerService: TaskManagerService,
              private snackBarService: SnackBarService,
              private taskManagerStore: Store<TaskManagerState>,
              private securityStore: Store<SecurityState>,
              protected commandService: CommandService) { }

  ngOnInit(): void {
    this.securityStore.select(getUserInfo).pipe(takeUntil(this.unSubscribe)).subscribe(currentUser => {
      this.currentUser = currentUser;
      this.isSupportMember = this.currentUser.companyId === 'orbitaxsupport';
    });
    if (this.data.input.card) {
      this.card = this.data.input.card;
    }
    if (this.data.input.board) {
      this.board = this.data.input.board;
    }
    this.hasPermission = this.card && this.card.hasPermission;
    this.canOpenChat = this.hasOpenChatPermission();
    this.hasAddAttachmentPermission = this.hasPermissions() && this.taskMenuItemsMapper.hasOwnProperty('TaskAttachment');
    this.subscribeToInvalidatorListener();
    this.setCommentPermission();
  }

  private subscribeToInvalidatorListener() {
    this.taskManagerStore.pipe(select(getTaskViewUpdateInfo)).pipe(takeUntil(this.unSubscribe)).subscribe(updatedTaskViewInfo => {
      if (updatedTaskViewInfo && updatedTaskViewInfo.card && updatedTaskViewInfo.card.id === this.card.id) {
        this.card = updatedTaskViewInfo.card;
      }
    });
  }
  private setCommentPermission(): void {
    const permissionType = this.card.permissionLevel;
    if (this.card.scope == GraphqlContentScope.getScope(ContentScope.OrbitaxSupport) &&
      (TicketOwner > permissionType || permissionType > TicketAssignee)) {
      this.hasCommentPermission = false;
    }
  }
  private hasOpenChatPermission(): boolean {
    return (this.card.assignments.findIndex(people => people.assignedTo.email.toLowerCase() === this.currentUser.email.toLowerCase()) !== -1);
  }

  private invalidateTaskView(card: any) {
    this.data.input.taskInvalidator.next({card: card, sourceViewId: this.id});
  }

  onDescriptionEdit($event: MouseEvent) {

  }

  onAddAttachment() {
    // show attachment dialog
    this.actionEvent$.emit({id: '', type: 'AddAttachment', card: this.card});
  }

  onAddComment() {
    // focus on comment box
    this.actionEvent$.emit({id: '', type: 'AddComment', card: this.card});
  }
  onOpenChat() {
    this.actionEvent$.emit({id: '', type: 'OpenChat', card: this.card});
  }

  onCreateSubtask() {
    // only for parent task
    // show subtask window and foucs on editor
    this.actionEvent$.emit({id: 'SubTask', type: 'MainViewBodyChangeEvent', card: this.card});
  }

  startTitleEdit($event: MouseEvent) {
    // this.resetDescriptionEditing();
    if (this.hasPermission) {
      this.isTitleEditing = true;
    }
  }

  resetTitleEditing() {
    this.isTitleEditing = false;
  }

  taskTitleChanged($event: any) {
    this.card.title = $event.text;
    this.resetTitleEditing();
    this.updateDetails();
  }

  private updateDetails() {
    this.card.taskStartDate = this.card.startDate;
    const updateTaskCommand = this.taskManagerService.getAddOrUpdateTaskCommand(this.board, this.card);
    this.commandService.executePlatformCommand(updateTaskCommand).pipe(take(1)).subscribe(response => {
      this.resetTitleEditing();
      this.invalidateTaskView(this.card);
    }, err => {
      this.snackBarService.showError('Update failed!');
    });
  }

  private hasPermissions(): boolean {
    const permissionType = this.card.permissionLevel;
    return (TicketOwner <= permissionType && permissionType <= TicketAssignee);
  }

  ngOnDestroy(): void {
    this.unSubscribe.next();
    this.unSubscribe.complete();
  }
}
